import { render } from "./Password.vue?vue&type=template&id=b71faedc&scoped=true&ts=true"
import script from "./Password.vue?vue&type=script&lang=ts"
export * from "./Password.vue?vue&type=script&lang=ts"

import "./Password.vue?vue&type=style&index=0&id=b71faedc&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\HESEL\\DCS\\Client\\vuejs-dcs\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71faedc"]])

export default __exports__